import i18n from 'i18n/config';

export const getTimeZones = () =>
  Array.from({ length: 27 }, (_, i) => {
    const timeZone = i - 12;

    const nonZeroSign = timeZone > 0 ? '+' : '';
    const sign = timeZone ? nonZeroSign : '±';
    const gmtCount = sign + timeZone;

    const nonZeroKey = timeZone > 0 ? `plus_${timeZone}` : `minus_${Math.abs(timeZone)}`;
    const keyPart = timeZone ? nonZeroKey : '0';

    return { timezone: timeZone, title: `GMT ${gmtCount}: ${i18n.t(`time_zones.gmt_${keyPart}`)}` };
  });
